/**
 * Created by tong on 2018/2/3.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Icon, LocaleProvider, Upload} from 'antd'
import enUS from 'antd/lib/locale-provider/en_US';
import {hashHistory, withRouter} from 'react-router';
import {AdvanceFormNew, DmsTab, TableView} from '../../components';
import {openNotice, toImportExcel, downLoadTemplate, config} from 'Utils';
import {addProductEnFavorites, getProductListEn} from '../../service/product';
import '../product/product.css';

class ProductEnList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['Price Query'],
            visible: false,
            total: '',
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
            searchObj: {
                name: '', /*物料名称 筛选*/
                favorites: false,
                s: 10,
                p: 1
            },
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
    };


    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };

    /*筛选重置*/
    advanceReset() {
        let self = this;
        self.setState({
            searchObj: {
                ...this.state.searchObj,
                name: '', /*物料名称 筛选*/
                s: 10,
                p: 1
            },
        });
    };

    /* 筛选确认 */
    advanceSubmit() {
        let self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                p: 1,
                favorites: this.state.searchObj.favorites ? 1 : 0
            }
        }, () => {
            self.initData();
        });
    };

    handleCancel = () => {
        this.setState({visible: false});
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        if (!searchObj.name && !searchObj.favorites) {
            openNotice('warning', 'Please fill in the material name for query first');
            return
        }
        self.setState({
            loading: true
        })

        getProductListEn(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    'rows': result.data || [],
                    'total': result.total,
                    'loading': false
                });
            } else {
                openNotice('error', 'Data acquisition failed', '');
                self.setState({'loading': false});
            }
        });
    }

    componentDidMount() {
    }

    downloadChange() {
        downLoadTemplate(12);
    }

    export() {
        let url = `${config.server}/api/v1/dms/product/productListPcEnExport`;
        window.open(url);
    }


    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}});
    }

    addSave = (record, index, value) => {
        var self = this;
        var add = {id: record.id};
        addProductEnFavorites(add).then(function (result) {
            if (result && result.code == 200) {
                //openNotice('success', '收藏成功', '');
                self.initData();
            } else {
                openNotice('error', 'fail', (result && result.message) ? result.message : '');
            }
        });

    };

    render() {
        const {
            opts,
            rows,
            total,
            searchObj,
            loading,
            button_limits_end
        } = this.state;

        let tableViewProps = {};
        let advanceProps = {};

        if (button_limits_end.productEn_import) {
            tableViewProps = {
                loading: loading,//更新表格数据中
                //rowKey: 'id',
                language: "en",
                pageParam: {
                    total: total,
                    current: searchObj.p,//当前页码
                    pageSize: searchObj.s,//当前分页数
                    onChange: this.pageChange
                },
                columns: [
                    {
                        title: 'Product Code',
                        dataIndex: 'itemNum',
                    },
                    {
                        title: 'Product Chinese Description',
                        dataIndex: 'itemDesc',
                    },
                    {
                        title: 'Product English Description',
                        dataIndex: 'custItemDesc',
                    },
                    {
                        title: 'Price',
                        dataIndex: 'custPrice',
                        render: text => <span style={{color: '#d61518'}}>{text}</span>
                    },
                    {
                        title: 'Cust Code',
                        dataIndex: 'custItemNum',
                    },
                    {
                        title: 'Barcode',
                        dataIndex: 'barcode',
                    },
                    {
                        title: 'Unit',
                        dataIndex: 'unit'
                    },
                    {
                        title: 'Qty of Carton',
                        dataIndex: 'qtyOfCarton',
                    },
                    {
                        title: 'G.W. (KG)',
                        dataIndex: 'grossWeigth',
                    },
                    {
                        title: 'N.W. (KG)',
                        dataIndex: 'netWeigth',
                    },
                    {
                        title: 'Country',
                        dataIndex: 'country'
                    },
                    {
                        title: 'Favorite',
                        dataIndex: 'favorites',
                        render: (text, record, index) => {
                            if (text) {
                                return <Button onClick={this.addSave.bind(this, record, index)}><Icon type="star"
                                                                                                      style={{color: '#579591'}}/></Button>
                            } else {
                                return <Button onClick={this.addSave.bind(this, record, index)}><Icon
                                    style={{color: '#579591'}} type="star-o"/></Button>
                            }
                        }
                    }
                ],
                rows
            };

            advanceProps = {
                fileds: [
                    {
                        name: 'name',
                        label: 'Material Name/Number',
                        text: 'Enter material name/number',
                        type: 'default',
                        defaultValue: searchObj.name,
                        labelStyle: {width: "200px"}
                    },
                    {
                        name: 'favorites',
                        label: 'Favorite',
                        text: 'Favorite',
                        type: 'SwitchInput',
                        defaultValue: searchObj.favorites,
                        labelStyle: {width: "500px"}
                    }
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            };

        } else {
            tableViewProps = {
                loading: loading,//更新表格数据中
                //rowKey: 'id',
                language: "en",
                pageParam: {
                    total: total,
                    current: searchObj.p,//当前页码
                    pageSize: searchObj.s,//当前分页数
                    onChange: this.pageChange
                },
                columns: [
                    {
                        title: 'Product Code',
                        dataIndex: 'itemNum',
                    },
                    {
                        title: 'Product Chinese Description',
                        dataIndex: 'itemDesc',
                    },
                    {
                        title: 'Product English Description',
                        dataIndex: 'custItemDesc',
                    },
                    {
                        title: 'Price',
                        dataIndex: 'custPrice',
                        render: text => <span style={{color: '#d61518'}}>{text}</span>
                    },
                    {
                        title: 'Cust Code',
                        dataIndex: 'custItemNum',
                    },
                    {
                        title: 'Barcode',
                        dataIndex: 'barcode',
                    },
                    {
                        title: 'Unit',
                        dataIndex: 'unit'
                    },
                    {
                        title: 'Qty of Carton',
                        dataIndex: 'qtyOfCarton',
                    },
                    {
                        title: 'G.W. (KG)',
                        dataIndex: 'grossWeigth',
                    },
                    {
                        title: 'N.W. (KG)',
                        dataIndex: 'netWeigth',
                    },
                    {
                        title: 'Country',
                        dataIndex: 'country'
                    }
                ],
                rows
            };

            advanceProps = {
                fileds: [
                    {
                        name: 'name',
                        label: 'Material Name/Number',
                        text: 'Enter material name/number',
                        type: 'default',
                        defaultValue: searchObj.name,
                        labelStyle: {width: "200px"}
                    }
                ],
                handle: this.advanceSubmit,
                reset: this.advanceReset,
                fieldHandle: this.setFilterParam
            };
        }


        let uploadParam = toImportExcel(
            12,
            () => {
                this.initData();
            }
        );
        return <LocaleProvider locale={enUS}>
            <div>
                <DmsTab options={opts} defaultKey={0}>
                    {button_limits_end.productEn_import &&
                        <Button style={{}} onClick={this.export.bind(this)}><Icon type="export"/>Export Favorite</Button>
                    }
                    {button_limits_end.productEn_import &&
                        <Button style={{}} onClick={this.downloadChange.bind(this)}><Icon type="download"/>Download
                            Template</Button>
                    }
                    {button_limits_end.productEn_import && <Upload {...uploadParam}>
                        <Button>
                            <Icon type="upload"/>Import
                        </Button>
                    </Upload>}
                </DmsTab>
                <div className="advanceForm-box">
                    <div className="advanceForm-content">
                        <AdvanceFormNew {...advanceProps}/>
                    </div>
                </div>
                <div className="dms-table-box">
                    <TableView {...tableViewProps}/>
                </div>
            </div>
        </LocaleProvider>
    }
}

export default withRouter(ProductEnList);



// WEBPACK FOOTER //
// ./src/routes/product/listEn.js